import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import "./Databases.css";
import DatabaseCard from "./DatabaseCard";
import usePageTitle from "../usePageTitle";

const Databases = () => {
  usePageTitle("Databases - SkeyeForm™");
  const [databases, setDatabases] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDatabases = async () => {
      setLoading(true);
      try {
        const response = await api.get("/databases/info");
        setDatabases(response.data);
      } catch (error) {
        console.error("Error fetching databases:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDatabases();
  }, []);

  return (
    <div className="toolbar-page">
      <div className="p-col title">
        <h1>Databases</h1>
        <div className="toolbar-bar"></div>
      </div>

      <div className="database-cards-container">
        {loading ? (
          <p>Loading...</p>
        ) : databases.length > 0 ? (
          databases.map((database, index) => (
            <DatabaseCard key={index} database={database} />
          ))
        ) : (
          <p>No Databases Found</p>
        )}
      </div>
    </div>
  );
};

export default Databases;
